import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { theme } from "@pluxee-design-system/core";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "datePicker",
    "dateInput",
    "headerIcon",
    "weekday",
]);
const rangePickerCommonStyle = {
    width: "155px",
    border: "none",
    backgroundColor: "transparent",
    _hover: {},
    _active: {},
    _focusVisible: {},
    _focus: {},
};
const baseStyle = definePartsStyle({
    datePicker: {
        ".react-datepicker": {
            boxSizing: "border-box",
            position: "relative",
            width: "296px",
            fontFamily: theme.fonts.core[1],
            borderRadius: "none",
            border: "1px solid",
            borderColor: "semantic.border.primary",
            backgroundColor: "semantic.surface.1",
            boxShadow: "large",
        },
        ".react-datepicker-popper": {
            zIndex: "dropdown",
            "&[data-placement^='bottom']": {
                paddingTop: "4px",
            },
        },
        ".react-datepicker__header": {
            width: "100%",
            height: "80px",
            padding: 0,
            backgroundColor: "transparent",
            border: "none",
        },
        ".react-datepicker__header--custom": Object.assign(Object.assign({ position: "relative", display: "flex", flexDirection: "column" }, theme.textStyles.body.largeDemibold), { color: "semantic.text.primary", borderRadius: "none", "&>div:first-child": {
                height: "40px",
                padding: "7px 11px 8px",
            }, "&>div:last-child": {
                height: "40px",
                padding: "0px 7px",
            } }),
        ".react-datepicker__month-container": {
            boxSizing: "border-box",
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
        },
        ".react-datepicker__month": {
            boxSizing: "border-box",
            position: "relative",
            width: "100%",
            margin: 0,
            padding: "8px 7px 7px",
        },
        ".react-datepicker__week": {
            boxSizing: "border-box",
            width: "100%",
            position: "relative",
            display: "flex",
            borderLeft: "1px solid",
            borderLeftColor: "semantic.border.secondary",
            borderRight: "1px solid",
            borderRightColor: "semantic.border.secondary",
            "&:first-child": {
                borderTop: "1px solid",
                borderTopColor: "semantic.border.secondary",
            },
            "&:last-child": {
                borderBottom: "1px solid",
                borderBottomColor: "semantic.border.secondary",
            },
        },
        ".react-datepicker__day-names": {
            height: "40px",
            display: "flex",
            margin: 0,
            padding: 0,
        },
        ".react-datepicker__day-name": Object.assign(Object.assign({ display: "flex", flex: 1, alignItems: "center", justifyContent: "center", margin: 0, padding: "4px", color: "semantic.text.secondary" }, theme.textStyles.body.smallDemibold), { textTransform: "capitalize" }),
        ".react-datepicker__day": Object.assign(Object.assign({ color: "semantic.text.primary" }, theme.textStyles.body.mediumBold), { boxSizing: "border-box", width: "40px", height: "40px", position: "relative", display: "flex", flex: 1, alignItems: "center", justifyContent: "center", padding: "3px", margin: 0, border: "1px solid", borderColor: "semantic.border.secondary", ":hover:not(.react-datepicker__day--disabled)": {
                backgroundColor: "semantic.background.info",
                color: "semantic.interactive.primary",
                borderRadius: 0,
                borderColor: "semantic.interactive.primary",
            }, ":focus-visible": {
                outline: "none",
            } }),
        ".react-datepicker__day--in-selecting-range": {
            backgroundColor: "semantic.background.info",
            color: "semantic.interactive.primary",
            borderRadius: 0,
        },
        ".react-datepicker__day--in-range": {
            borderRadius: 0,
            backgroundColor: "semantic.interactive.primary",
            color: "semantic.text.inverse",
            "&:not(.react-datepicker__day--in-selecting-range)": {
                backgroundColor: "semantic.background.info",
            },
        },
        ".react-datepicker__day.react-datepicker__day--selected": {
            borderRadius: 0,
            backgroundColor: "semantic.interactive.primary",
            color: "semantic.text.inverse",
        },
        ".react-datepicker__day.react-datepicker__day--keyboard-selected": {
            backgroundColor: "semantic.background.info",
            color: "semantic.interactive.primary",
            borderRadius: 0,
            borderColor: "semantic.interactive.primary",
            border: "1px solid",
        },
        ".react-datepicker__day.react-datepicker__day--disabled": {
            color: "semantic.text.disabled",
        },
        ".react-datepicker__day.react-datepicker__day--outside-month": {
            color: "semantic.text.disabled",
            ":hover": {
                color: "semantic.interactive.primary",
            },
        },
        ".react-datepicker__day.react-datepicker__day--selected.react-datepicker__day--outside-month": {
            color: "semantic.text.inverse",
        },
        "input.react-datepicker-time__input": {
            border: "1px solid",
            borderColor: "semantic.border.primary",
            padding: "2px",
        },
    },
});
const variants = {
    default: definePartsStyle({
        dateInput: {
            width: "334px",
            display: "flex",
            alignItems: "center",
        },
        headerIcon: {
            height: "auto",
            minWidth: "fit-content",
            color: "semantic.icon.secondary",
            _hover: {
                color: "semantic.icon.info",
            },
        },
    }),
    rangePicker: definePartsStyle({
        dateInput: Object.assign({ paddingRight: 0 }, rangePickerCommonStyle),
    }),
    rangePickerRight: definePartsStyle({
        dateInput: Object.assign({ paddingX: 0 }, rangePickerCommonStyle),
    }),
};
const DatePickerTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: "default",
    },
});
export default DatePickerTheme;
//# sourceMappingURL=DatePicker.default.js.map